const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Formularios Web",
    summary:
      "Crea formularios web públicos para captura de clientes potenciales, registros y solicitudes de soporte. Las respuestas ingresan directamente al sistema generando contactos y tickets automáticos.",
  },
  sections: [
    {
      id: "gestion_formularios",
      title: "1. Gestión de Formularios",
      description:
        "Diseño de campos, validaciones y configuración del formulario público.",
      items: [
        {
          id: "campos_formulario",
          title: "Campos Personalizados",
          definition:
            "Agrega campos de texto, correo, teléfono, menús desplegables y opciones requeridas para capturar la información clave del cliente.",
        },
        {
          id: "enlace_publico",
          title: "Enlace y Compartir",
          definition:
            "Obtén la URL pública o código de incrustación para publicar el formulario en sitios web, landing pages o redes sociales.",
        },
      ],
    },
    {
      id: "automatizacion_leads",
      title: "2. Creación Automática de Tickets",
      description:
        "Asignación de cola, etiqueta y usuario responsable tras el envío del formulario.",
      items: [
        {
          id: "destino_tickets",
          title: "Cola y Etiqueta Destino",
          definition:
            "Define a qué departamento ingresará la solicitud del cliente para su atención inmediata por el equipo.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Web Forms",
    summary:
      "Create public web forms for lead generation, customer signups, and support requests. Submissions flow directly into the system creating contacts and tickets automatically.",
  },
  sections: [
    {
      id: "gestion_formularios",
      title: "1. Form Management",
      description:
        "Field designer, validation rules, and public form configurations.",
      items: [
        {
          id: "campos_formulario",
          title: "Custom Form Fields",
          definition:
            "Add text inputs, email, phone, drop-down selects, and required constraints to collect customer details.",
        },
        {
          id: "enlace_publico",
          title: "Public URL & Sharing",
          definition:
            "Get the public shareable link or embed snippet to integrate your form on landing pages or social channels.",
        },
      ],
    },
    {
      id: "automatizacion_leads",
      title: "2. Automated Ticket Routing",
      description:
        "Assign queues, tags, and agent ownership upon each form submission.",
      items: [
        {
          id: "destino_tickets",
          title: "Target Queue & Tags",
          definition:
            "Specify the department where incoming requests will land for immediate attention by your team.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Formulários Web",
    summary:
      "Crie formulários web públicos para captação de leads, cadastros e solicitações de suporte. As respostas geram contatos e tickets automaticamente na plataforma.",
  },
  sections: [
    {
      id: "gestion_formularios",
      title: "1. Gestão de Formulários",
      description:
        "Estrutura de campos, validações e configurações públicas.",
      items: [
        {
          id: "campos_formulario",
          title: "Campos Personalizados",
          definition:
            "Adicione campos de texto, e-mail, telefone, seletores e opções obrigatórias para capturar dados essenciais.",
        },
        {
          id: "enlace_publico",
          title: "Link Público e Compartilhamento",
          definition:
            "Gere o link direto ou código de integração para divulgar o formulário em páginas da web ou redes sociais.",
        },
      ],
    },
    {
      id: "automatizacion_leads",
      title: "2. Encaminhamento de Tickets",
      description:
        "Defina filas, tags e responsáveis automáticos para cada preenchimento.",
      items: [
        {
          id: "destino_tickets",
          title: "Fila e Tags de Destino",
          definition:
            "Indique o setor responsável onde a solicitação será aberta para atendimento imediato.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Formulaires Web",
    summary:
      "Créez des formulaires web publics pour capturer des prospects, inscriptions ou demandes de support. Chaque envoi génère automatiquement des contacts et des tickets.",
  },
  sections: [
    {
      id: "gestion_formularios",
      title: "1. Gestion des Formulaires",
      description:
        "Conception des champs, règles de validation et affichage public.",
      items: [
        {
          id: "campos_formulario",
          title: "Champs Personnalisés",
          definition:
            "Ajoutez des champs de texte, téléphone, e-mail et listes déroulantes pour collecter les informations requises.",
        },
        {
          id: "enlace_publico",
          title: "Lien Public et Partage",
          definition:
            "Récupérez l'URL publique ou le code d'intégration pour insérer le formulaire sur votre site ou vos pages d'atterrissage.",
        },
      ],
    },
    {
      id: "automatizacion_leads",
      title: "2. Routage Automatique des Tickets",
      description:
        "Assignation automatique de files d'attente et d'étiquettes à chaque soumission.",
      items: [
        {
          id: "destino_tickets",
          title: "File d'attente et Étiquettes",
          definition:
            "Définissez le département qui prendra en charge la demande client dès réception.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "نماذج الويب (Web Forms)",
    summary:
      "أنشئ نماذج ويب عامة لجمع بيانات العملاء المحتملين والطلبات وتسجيلات الدعم الفني. يتم تحويل كل إرسال تلقائياً إلى جهة اتصال وتذكرة دعم داخل النظام.",
  },
  sections: [
    {
      id: "gestion_formularios",
      title: "1. إدارة النماذج",
      description:
        "تصميم الحقول وقواعد التحقق والإعدادات العامة للنموذج.",
      items: [
        {
          id: "campos_formulario",
          title: "حقول النموذج المخصصة",
          definition:
            "أضف حقول النص والبريد الإلكتروني ورقم الهاتف والقوائم المنسدلة لجمع بيانات العميل.",
        },
        {
          id: "enlace_publico",
          title: "الرابط العام والمشاركة",
          definition:
            "احصل على الرابط المباشر للنموذج أو كود التضمين لمشاركته في موقعك الإلكتروني أو حملاتك.",
        },
      ],
    },
    {
      id: "automatizacion_leads",
      title: "2. توجيه التذاكر التلقائي",
      description:
        "تعيين الأقسام والوسوم والموظفين المسؤولين فور إرسال النموذج.",
      items: [
        {
          id: "destino_tickets",
          title: "القسم والوسوم المستهدفة",
          definition:
            "حدد القسم الذي ستصل إليه طلبات العملاء للبدء في معالجتها فوراً.",
        },
      ],
    },
  ],
};

export const FORMS_HELP_DATA = { es, en, pt, fr, ar };
export default FORMS_HELP_DATA;
